/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminDepositAmountRespVo
 */
export interface AdminDepositAmountRespVo {
    /**
     * 全部预存款余额总计（中国+韩国）
     * @type {number}
     * @memberof AdminDepositAmountRespVo
     */
    totalAmount?: number;
    /**
     * 中国预存款余额总计
     * @type {number}
     * @memberof AdminDepositAmountRespVo
     */
    chinaAmount?: number;
    /**
     * 韩国预存款余额总计
     * @type {number}
     * @memberof AdminDepositAmountRespVo
     */
    koreaAmount?: number;
}

/**
 * Check if a given object implements the AdminDepositAmountRespVo interface.
 */
export function instanceOfAdminDepositAmountRespVo(value: object): value is AdminDepositAmountRespVo {
    return true;
}

export function AdminDepositAmountRespVoFromJSON(json: any): AdminDepositAmountRespVo {
    return AdminDepositAmountRespVoFromJSONTyped(json, false);
}

export function AdminDepositAmountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDepositAmountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'chinaAmount': json['chinaAmount'] == null ? undefined : json['chinaAmount'],
        'koreaAmount': json['koreaAmount'] == null ? undefined : json['koreaAmount'],
    };
}

export function AdminDepositAmountRespVoToJSON(json: any): AdminDepositAmountRespVo {
    return AdminDepositAmountRespVoToJSONTyped(json, false);
}

export function AdminDepositAmountRespVoToJSONTyped(value?: AdminDepositAmountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalAmount': value['totalAmount'],
        'chinaAmount': value['chinaAmount'],
        'koreaAmount': value['koreaAmount'],
    };
}

